import { Injectable, inject } from '@angular/core';

import { CountryFlagsConfig } from '@frontend/sports/common/client-config-data-access';
import { NativeAppService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class CountryFlagsConfigService {
    private countryFlagsConfig = inject(CountryFlagsConfig);
    private nativeAppService = inject(NativeAppService);

    getFlagName(regionId: string): string {
        if (!regionId) {
            return '';
        }
        if (this.nativeAppService.isTerminal) {
            return `country-icon c${regionId}`;
        }
        const flagName = this.countryFlagsConfig.countryFlagNames[regionId];
        return flagName ? `${flagName.toLowerCase()}-flag` : 'default-flag';
    }
}
